<template>
    <div>
        <div
                v-if="backToTopBox.show"
                @click="voidBackToTopHandle"
                @mouseover="voidBackToTopHandle"
                @mouseout="voidBackToTopHandle"
                class="style_cursor no_select fixed-top position-absolute h-100"
                :style="{'width': '150px'}"
        >
            <div
                    class="box_back_to_top opacity-50 h-100 css_styleColor4 p-l-16 p-t-16"
                    :style="{'background-color': backToTopBox.isOver ? 'rgba(224, 224, 224, 0.5)' : ''}"
            >
                <div class="box_text_back_to_top position-sticky d-flex">
                    <div class="align-items-start">
                        <img
                                v-if="backToTopBox.isOnTop"
                                src="../../../assets/icons/up_blue.svg" class="m-r-8 back_to_top_icon" height="10">
                        <img
                                v-if="!backToTopBox.isOnTop"
                                src="../../../assets/icons/down_blue.svg" class="m-r-8 back_to_top_icon" height="10">
                    </div>
                    <div class="back_to_top_text">{{backToTopBox.isOnTop ? 'Назад' : ''}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeUnmount, reactive/*, ref, watch, onBeforeMount,*/ } from 'vue'
import {backToTopHandle, showOrHideBackToTopBox} from "../../../pages/article/services/backToTopHandler";

export default {
    setup() {
        const backToTopBox = reactive({
            scrollTop: null,
            show: true,
            isOnTop: true,
            isOver: false
        });

        showOrHideBackToTopBox(backToTopBox);

        const voidBackToTopHandle = (event) => {
            backToTopHandle(event, backToTopBox)
        }

        window.addEventListener('scroll', voidBackToTopHandle);
        window.addEventListener('resize', voidBackToTopHandle);

        onBeforeUnmount(() => {
            window.removeEventListener('scroll', voidBackToTopHandle);
            window.removeEventListener('resize', voidBackToTopHandle);
        });

        return {
            voidBackToTopHandle,
            backToTopBox
        }
    }
}
</script>

<style scoped>
    .box_back_to_top{
        width: 100px;
    }

    .box_text_back_to_top{
        top: 16px;
    }
</style>